import { render } from "./Demos.vue?vue&type=template&id=48f34bea"
import script from "./Demos.vue?vue&type=script&lang=js"
export * from "./Demos.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT\\TaleMakerWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__